/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2022-02-11 10:08:57
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-27 01:07:58
 */
export default {
  baseApi: '/api/',  // 后端接口地址

  // viewUrl必须使用hash路由，因为后台需要预览使用hash路由的地址

  // viewUrl: 'http://localhost:8080/#/',          // iframe嵌套的H5地址,本地开发可改为本地启动的H5地址
  // formUrl: 'http://localhost:3000'

  viewUrl: 'https://fankeymice.com/#/',          // iframe嵌套的H5地址,本地开发可改为本地启动的H5地址
  formUrl: 'https://table.fankeymice.com'
}
